import React from 'react';
import Svg, { Circle, G } from 'react-native-svg';
import getPriorityColor from './PriorityColorScheme';

type Props = {
  other: number;
  low: number;
  normal: number;
  high: number;
  urgent: number;
  compareOther: number;
  compareLow: number;
  compareNormal: number;
  compareHigh: number;
  compareUrgent: number;
  compareToggled: boolean;
  radius: number;
  stroke?: number;
};

const CircleChart = (props: Props) => {
  const strokeWidth: number = props.stroke ?? 14;
  const innerRadius: number = props.radius - strokeWidth - 4;
  const translateVal: number = props.radius + strokeWidth;

  const Arc = (rotation: number, value: number, stroke: string, r: number) => <G
    rotation={(360 / 100) * rotation}
    translate={[translateVal, translateVal]}
  >
    <Circle
      {...{ stroke, r }}
      fill='transparent'
      {...{ strokeWidth }}
      strokeDasharray={Math.PI * (props.radius * 2)}
      strokeDashoffset={Math.PI * (props.radius * 2) - (value / 100) * (Math.PI * (r * 2))}
    />
  </G>;

  const containerSize: number = props.radius ? (props.radius + strokeWidth) * 2 : 265;

  return <Svg
    style={{
      width: containerSize,
      height: containerSize,
      transform: [{ rotateZ: '-90deg' }],
    }}
  >
    {Arc(0, props.urgent, getPriorityColor(0), props.radius)}
    {Arc(props.urgent, props.high, getPriorityColor(1), props.radius)}
    {Arc(props.urgent + props.high, props.normal, getPriorityColor(2), props.radius)}
    {Arc(props.urgent + props.high + props.normal, props.low, getPriorityColor(3), props.radius)}
    {Arc(
      props.urgent + props.high + props.normal + props.low,
      props.other,
      getPriorityColor(4),
      props.radius,
    )}
    {props.compareToggled && <>
      {Arc(0, props.compareUrgent, getPriorityColor(0), innerRadius)}
      {Arc(props.compareUrgent, props.compareHigh, getPriorityColor(1), innerRadius)}
      {Arc(
        props.compareUrgent + props.compareHigh,
        props.compareNormal,
        getPriorityColor(2),
        innerRadius,
      )}
      {Arc(
        props.compareUrgent + props.compareHigh + props.compareNormal,
        props.compareLow,
        getPriorityColor(3),
        innerRadius,
      )}
      {Arc(
        props.compareUrgent + props.compareHigh + props.compareNormal + props.compareLow,
        props.compareOther,
        getPriorityColor(4),
        innerRadius,
      )}
    </>}
  </Svg>;
};

export default CircleChart;
